/* PD legal pages (handelsbetingelser, fortrydelsesret, withdrawal-form). The text is merchant
   content and stays byte-for-byte as typed; this only adds structure — headings typed as plain
   paragraphs get heading style, empty paragraphs go, the pasted code-block wrapper around the PDF
   link is unwrapped, and a heading that just repeats the page title is dropped. Merchant
   2026-09-23: "ALT teksten skal være fuldstændig urørt, men det må gerne moderniseres med fed". */
(function () {
  var LEGAL = /\/pages\/(handelsbetingelser|fortrydelsesret|withdrawal-form)(\/|\?|#|$)/;   // + every /policies/* page
  function txt(el) { return (el && el.textContent || "").replace(/ /g, " ").replace(/\s+/g, " ").trim(); }
  function init() {
    var main = document.getElementById("MainContent"); if (!main) return;
    // Shopify's built-in /policies/* pages use their own markup (.shopify-policy__container); same treatment
    var legal = LEGAL.test(location.pathname) || /^\/policies\//.test(location.pathname) || main.classList.contains("pd-legal-page");
    var rte = main.querySelector(".page__content.rte") || main.querySelector(".shopify-policy__body .rte") || main.querySelector(".shopify-policy__body");   // innermost first: a grouped selector returns the outer wrapper (document order)
    main.classList.toggle("pd-legal-page", legal && !!rte);
    if (!legal || !rte || rte.dataset.pdLegal) return; rte.dataset.pdLegal = "1";
    rte.classList.add("pd-legal");
    var title = txt(main.querySelector(".page__title, .shopify-policy__title h1, .shopify-policy__title")).toLowerCase();
    // 1. a pasted wrapper (nested divs) around a file link → one paragraph holding the same link
    Array.prototype.slice.call(rte.children).forEach(function (el) {
      if (el.tagName !== "DIV") return;
      // an app's mount point is empty until its script fills it: the withdrawal form's
      // <div class="bew-withdrawal-form-mount" data-boo-withdrawal-form> was removed here, so the page showed no form
      if (Array.prototype.some.call(el.attributes, function (a) { return a.name.indexOf("data-") === 0; })) return;
      var a = el.querySelector("a");
      if (a && txt(el) === txt(a)) { var p = document.createElement("p"); p.className = "pd-legal__file"; p.appendChild(a); el.replaceWith(p); }
      else if (!txt(el) && !el.querySelector("img,a")) el.remove();
    });
    // 2. empty headings and paragraphs (<h2><b><br></b></h2>, <p>&nbsp;</p> …)
    Array.prototype.slice.call(rte.querySelectorAll("h1,h2,h3,h4,p")).forEach(function (el) { if (!txt(el) && !el.querySelector("img,a")) el.remove(); });
    // 3. the page title repeated as the first line of the text
    var first = rte.firstElementChild;
    if (first && (/^H[1-6]$/.test(first.tagName) || first.tagName === "P") && txt(first).toLowerCase() === title) first.remove();
    // 4. a bold label at the start of a paragraph, then <br>, then the text (Google-Docs paste wraps
    //    each piece in a <span>) → the label becomes its own heading line, the text stays in place
    Array.prototype.slice.call(rte.querySelectorAll("p")).forEach(function (p) {
      var b = p.querySelector("strong,b"); if (!b) return;
      var r = document.createRange(); r.setStart(p, 0); r.setEndBefore(b);
      if (txt({ textContent: r.toString() })) return;   // something precedes the bold: not a label
      var w = document.createTreeWalker(p, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT), n, br = null, seen = false;
      // the <br> may sit INSIDE the bold (<strong>Varens stand…<br></strong>) — take it from there
      var tail = b.lastChild; while (tail && tail.nodeType === 1 && tail.tagName === "SPAN" && tail.lastChild) tail = tail.lastChild;
      if (tail && tail.nodeType === 1 && tail.tagName === "BR") { br = tail; seen = true; }
      while (!br && (n = w.nextNode())) {
        if (n === b) { seen = true; continue; }
        if (!seen || b.contains(n)) continue;
        if (n.nodeType === 1 && n.tagName === "BR") { br = n; break; }
        if (n.nodeType === 3 ? txt(n) : (n.tagName !== "SPAN" || txt(n))) break;   // real text before any <br>: not a label
      }
      if (!br) return;
      var h = document.createElement("p"); h.className = "pd-legal__h"; h.appendChild(b); br.remove(); p.parentNode.insertBefore(h, p);
      Array.prototype.slice.call(p.querySelectorAll("span")).forEach(function (sp) { if (!txt(sp) && !sp.querySelector("br,img,a")) sp.remove(); });
      if (!txt(p) && !p.querySelector("img,a")) p.remove();
    });
    // 5. headings: real ones, bold-only paragraphs, and short label lines followed by a longer block
    var els = Array.prototype.slice.call(rte.children);
    els.forEach(function (el, i) {
      var t = txt(el); if (!t) return;
      if (/^H[1-6]$/.test(el.tagName)) { el.classList.add("pd-legal__h"); return; }
      if (el.tagName !== "P" || el.classList.contains("pd-legal__file")) return;
      var bold = el.querySelector("strong,b");
      var boldOnly = !!bold && txt(bold) === t;
      var next = els[i + 1];
      // short, starts with a capital, no digits or commas (address lines have both), nothing sentence-like at the end, and a longer block follows
      var labelLike = t.length <= 48 && !/[\d,]/.test(t) && !/[.:!?;)]$/.test(t) && /^[A-ZÆØÅ]/.test(t) && !!next && /^(P|UL|OL)$/.test(next.tagName) && txt(next).length > t.length;
      if (boldOnly || labelLike) el.classList.add("pd-legal__h");
    });
    var h1 = rte.querySelector(".pd-legal__h"); if (h1 && h1 === rte.firstElementChild) h1.classList.add("pd-legal__h--first");
    // 6. an enumerated line that starts lower-case ("2) pengene frigives …") gets its capital — display
    //    only, the page content in Shopify is not touched (merchant 2026-09-23: "pengene står med småt")
    var tw = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT), tn;
    while ((tn = tw.nextNode())) {
      var m = /^(\s*\d+[).]\s+)([a-zæøå])/.exec(tn.nodeValue);
      if (m) tn.nodeValue = m[1] + m[2].toUpperCase() + tn.nodeValue.slice(m[0].length);
    }
  }
  init();
  document.addEventListener("pd:navigated", init);
})();
